export function throttle(func, wait, context) {
  let lastTime = 0;
  return function (...args) {
    const now = Date.now();
    const timeSinceLast = now - lastTime;
    if (timeSinceLast >= wait) {
      func.apply(context || this, args);
      lastTime = now;
      return true; // 表示函数已执行
    }
    return false; // 表示函数未执行（被忽略）
  };
}

export function debounce(func, wait, immediate = false) {
  let timeout;

  return function () {
    const context = this;
    const args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}
